var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.75 10.5a.75.75 0 1 1 1.5 0c0 2.063.525 2.683 1.005 2.938.289.154.666.237 1.166.274.519.038 1.035.023 1.68.038h2.798c.645-.015 1.162 0 1.68-.038.5-.037.877-.12 1.166-.274.48-.255 1.005-.875 1.005-2.938a.75.75 0 1 1 1.5 0c0 2.26-.58 3.613-1.799 4.263-.56.298-1.18.402-1.761.445-.564.041-1.213.03-1.755.042h-2.87c-.542-.013-1.191 0-1.754-.042-.582-.043-1.202-.147-1.762-.445C2.33 14.113 1.75 12.76 1.75 10.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.97 6.03a.75.75 0 0 1 0-1.06l3-3 .056-.052a.75.75 0 0 1 1.004.052l3 3a.75.75 0 0 1-1.06 1.06L9.25 4.31v6.857a.75.75 0 0 1-1.5 0V4.31L6.03 6.03a.75.75 0 0 1-1.06 0"
  })));
};
export default Svg16;